var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useReducer, useRef } from 'react';
import useForkedVariable from './useForkedVariable';
/**
 * 动画关闭处理真实关闭状态
 * 通过 onAnimationEnd 回调实现 leaveCallback
 */
export default function useAnimationVisible(visible, afterClose) {
    var _a = __read(useReducer(function (c) { return !c; }, false), 2), handleRender = _a[1];
    var activeAnimation = useRef(0);
    // 可见状态分支
    var _b = __read(useForkedVariable(visible, function (modify) {
        // 可见状态：设置进入动画
        if (visible) {
            modify(visible);
            activeAnimation.current = 1;
        }
        else {
            activeAnimation.current = 2;
        }
    }), 2), realVisible = _b[0], modifyRealVisible = _b[1];
    function onAnimationEnd() {
        // 动画结束后触发渲染
        handleRender();
        // 结束动画：设置隐藏状态
        if (activeAnimation.current === 2) {
            modifyRealVisible(false);
            // 触发隐藏回调
            if (afterClose) {
                afterClose();
            }
        }
        // 重置状态
        activeAnimation.current = 0;
    }
    return [
        /**
         * 真实可见状态
         */
        realVisible,
        /**
         * 正在进行的动画
         */
        activeAnimation.current,
        /**
         * 动画结束后回调
         */
        onAnimationEnd,
    ];
}
